import * as React from 'react';

import { CollectionSurveyQuestions } from '@src/generated/hooks';

export interface SurveyHeadingProps {
  question: CollectionSurveyQuestions;
}

/**
 * @name SurveyHeading
 * @description The "survey question" and any "subtext"
 */
export const SurveyHeading = (props: SurveyHeadingProps) => {
  const { question } = props;

  // Hooks
  const { subtext } = question;

  return (
    <>
      <h1
        className="m-0 px-5 font-beatrice-regular text-2xl leading-normal md:px-0 md:font-beatrice-light md:text-4xl"
        dangerouslySetInnerHTML={{ __html: question.text }}
      />
      {subtext && (
        <div className="mt-2 text-sm md:mt-4 md:text-base">{subtext}</div>
      )}
    </>
  );
};
